import { DialogTitle } from '@radix-ui/react-dialog'
import Image from 'next/image'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import ProposalDates from '../proposal/proposal-information/proposal-dates/ProposalDates'
import Icon from '../../atoms/icons/icon/Icon'
import { NonCompliantLabel } from '../../molecules/non-compliant-rules/NonCompliantLabel'
import { Maybe, NonCompliantRulesFragment } from '../../../lib/graphql'
import { cn } from '../../../shadcn/utils'

export const ProposalModalHeader = ({
  startDate,
  endDate,
  title,
  adults,
  picture,
  onClose,
  nonCompliantRules,
}: {
  startDate?: Maybe<Date>
  endDate?: Maybe<Date>
  title?: string
  adults?: Maybe<number>
  picture?: string
  onClose?: () => void
  nonCompliantRules?: NonCompliantRulesFragment
}) => {
  const intl = useIntl()

  const nonCompliantLabel = (cls?: string) =>
    nonCompliantRules && (
      <aside
        className={cn(
          'flex flex-row items-center gap-2 rounded-full bg-orange-100 px-2 py-2 text-xs text-orange-500',
          cls,
        )}
      >
        <Icon size={24} name='info-outline' />
        <NonCompliantLabel clientProposal={nonCompliantRules} />
      </aside>
    )

  return (
    <header className='flex w-full flex-row items-center justify-between px-7 py-4'>
      <div className='flex items-center gap-4'>
        <Image
          width={60}
          height={60}
          alt={intl.formatMessage({
            id: 'ui.ProposalModalHeader.proposedLocation',
            defaultMessage: 'Lieu proposé',
          })}
          src={picture ?? '/default-wome.png'}
          className='size-16 rounded-md'
        />
        <div className='flex flex-col gap-2'>
          <DialogTitle className='text-base font-medium'>{title}</DialogTitle>

          <div className='flex gap-2 text-sm'>
            {startDate && endDate && (
              <ProposalDates startDate={startDate} endDate={endDate} />
            )}

            <span>&nbsp;|</span>

            <FormattedMessage
              defaultMessage='{participants, plural, =0 {Aucun participant} one {1 participant} other {{participants} participants}}'
              id='ui.ProposalModalHeader.numberOfParticipants'
              values={{ participants: adults }}
            />
          </div>
        </div>
        <div className='hidden lg:block'>{nonCompliantLabel('max-w-64')}</div>
      </div>
      <Icon
        className='h-3 w-3 self-start md:self-center'
        name='cross-without-circle'
        color='black'
        style={{ cursor: 'pointer' }}
        onClick={onClose}
      />
      {nonCompliantRules && (
        <div className='lg:hidden'>{nonCompliantLabel('w-fit')}</div>
      )}
    </header>
  )
}
